import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const REQUESTED_PARTS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('REQUESTED_PARTS');
export const REQUESTED_PARTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	REQUESTED_PARTS_CRUD_ACTION_CONSTANTS
);
